window.ValetStep5 = {

    init() {

        this.calendar = document.querySelector(
            "[data-valet-collection-calendar]"
        );

        if (!this.calendar) return;

        const calendar =
            this.calendar.__calendarInstance;

        if (calendar) {

            calendar.minSelectableDate =
                calendar.getMinSelectableDate();

            calendar.currentMonth =
                calendar.minSelectableDate.getMonth();

            calendar.currentYear =
                calendar.minSelectableDate.getFullYear();

            calendar.populateSelectors();

            calendar.renderCalendar();

        }

        this.bind();

        if (window.valetBooking.collectionDate) {

            this.updateSummary(
                window.valetBooking.collectionDate
            );

        }

    },

    bind() {

        this.calendar.removeEventListener(
            "calendar:selected",
            this.handleDate
        );

        this.calendar.addEventListener(
            "calendar:selected",
            this.handleDate
        );

    },

    handleDate(event) {

        const selectedDate =
            event.detail.date;

        window.valetBooking.collectionDate =
            selectedDate;

        window.ValetStep5.updateSummary(
            selectedDate
        );

    },

    updateSummary(date) {

        document
            .querySelectorAll(
                '[data-summary="collection-date"]'
            )
            .forEach(item => {

                item.textContent = date;

            });

    }

};